var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.413,
    height: 20.453,
    viewBox: "0 0 20.413 20.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#173c6d;stroke:#fff;stroke-miterlimit:10;stroke-width:.15px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15944",
    transform: "translate(0 .075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_9304",
    transform: "translate(5.21 5.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10383",
    d: "M620.367 627.15a.767.767 0 0 1-.56-.249.755.755 0 0 1 .052-1.066c.113-.1.221-.212.324-.325a4.408 4.408 0 0 0-.348-6.215.753.753 0 0 1 1-1.122 5.915 5.915 0 0 1 .466 8.342c-.136.153-.282.3-.433.438a.763.763 0 0 1-.501.197z",
    className: "cls-1",
    transform: "translate(-619.584 -617.981)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_9305",
    transform: "translate(8.376 3.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10384",
    d: "M621.723 630a.754.754 0 0 1-.513-1.308c.151-.139.3-.287.438-.44a6.886 6.886 0 0 0-.473-9.727.753.753 0 0 1 1.012-1.115 8.4 8.4 0 0 1 .579 11.851c-.17.186-.348.367-.534.539a.75.75 0 0 1-.509.2z",
    className: "cls-1",
    transform: "translate(-620.93 -617.218)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_9306",
    transform: "translate(11.514 1.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10385",
    d: "M623.073 633.291a.753.753 0 0 1-.517-1.3 9.914 9.914 0 0 0-.052-14.354.754.754 0 1 1 1.026-1.106 11.417 11.417 0 0 1 .059 16.554.738.738 0 0 1-.516.206z",
    className: "cls-1",
    transform: "translate(-622.264 -616.33)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_9307",
    transform: "translate(14.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10386",
    d: "M624.42 635.923a.754.754 0 0 1-.506-1.312 11.981 11.981 0 0 0-.063-17.676.753.753 0 1 1 1-1.122 13.482 13.482 0 0 1 .071 19.913.743.743 0 0 1-.502.197z",
    className: "cls-1",
    transform: "translate(-623.599 -615.62)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_767",
    cx: 2.318,
    cy: 2.318,
    r: 2.318,
    fill: "#173c6d",
    transform: "translate(0 7.671)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.e5e62d44b8d7d28ec088c30bd1e2a188.svg";
export { ForwardRef as ReactComponent };